<template>
	<div @click="hideMenu" v-b-toggle.sidebar-right v-if="$store.state.blackScreen" id="loading"></div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
	methods: {
		...mapMutations(["setBlackScreenOnState"]),
		hideMenu: function () {
			this.setBlackScreenOnState(false);
			this.$root.$emit("bv::toggle::collapse", "sidebar-right");
		}
	}
};
</script>

<style lang="scss" scoped>
#loading {
	background-color: #000000;
	opacity: 0.7;
	color: white;
	font-size: 32px;
	padding-top: 10vh;
	height: 100vh;
	text-align: center;
	position: fixed;
	width: 100%;
	z-index: 1000;
	cursor: unset !important;
}
</style>
